<template>
  <div class="form-wrapper h-100">
    <div class="form-wrapper__body container">
      <div
        v-if="header"
        class="col-12 header"
      >
        <slot name="header" />
      </div>
      <div
        class="col-12"
        :class="[
          fullWidth ? 'd-flex flex-column' : 'col-lg-9',
          { 'h-100 justify-content-center': fullHeight },
          { 'm-auto': center },
        ]"
      >
        <slot name="body" />
      </div>
    </div>

    <div class="form-wrapper__footer">
      <div
        class="col-12 d-flex justify-content-end"
        :class="{ 'col-lg-9': !fullFooter }"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FormWrapper',
  props: {
    header: {
      default: false,
      type: Boolean,
    },
    fullWidth: {
      default: false,
      type: Boolean,
    },
    fullFooter: {
      default: false,
      type: Boolean,
    },
    fullHeight: {
      default: false,
      type: Boolean,
    },
    center: {
      default: false,
      type: Boolean,
    },
  },
}
</script>
<style lang="scss">
@import '@/assets/scss/components/form-wrapper.scss';
</style>
